import { makeAutoObservable, runInAction } from 'mobx';
import ReadStore from '../read';
import navbarStore from '../navbar';
import { HelperCore } from '@/common/dependencies';
import { isStringEmpty } from '@shared/utils';
import appLogger from '@public/log/monitor';

class Store {
  readStore = null;
  conversationId = null;
  messageId = null;

  constructor () {
    this.readStore = new ReadStore({
      onIndexChange : (messageId) => {

      },
      onTextChange : (text) => {
  
      },
      onEnd : (messageId) => {
        // debug
        // HelperCore.log(`chatReadStore onEnd`, messageId);

        runInAction(() => {
          this.conversationId = null;
          this.messageId = null;
        });
      },
    });

    makeAutoObservable(this);

    if(!HelperCore.IS_PROD){
      window._chatReadStore = this;
    }
  }

  handleClick = ({ conversationId, messageId, content, roleId, agentId }) => {
    if(this.conversationId){
      if(this.conversationId == conversationId && this.messageId == messageId){
        this.readStore.stop();
        return;
      }
      this.readStore.stop();
    }

    const roleInfo = navbarStore.chatModels[roleId];
    if(!roleInfo && !agentId){
      console.error(`未查找到 ${roleId} 对应的模型信息`);
      return;
    }
    if(isStringEmpty(content)){
      return;
    }

    this.conversationId = conversationId;
    this.messageId = messageId;
    this.readStore.setIndex(messageId, {
      role : {
        uid : agentId ? agentId : roleInfo.id,
        tag : agentId ? agentId : roleInfo.tag,
      },
      type : "a",
      typing : false,
      content,
    });
  }

  /**
   * 是否支持朗读
   * @param {Object} message 
   */
  isSupportReadMessage (message) {
    if(!message){
      return false;
    }
    const { result, role_biz } = message;
    // 正文为空
    if(!result || isStringEmpty(result)){
      return false;
    }
    // 指定消息类型
    if([
      "page_mind",      // 思维导图
      "mind",           // 思维导图
      "draw",           // 文生图
      "ai_agent",       // 智能体
    ].includes(role_biz)){
      return false;
    }
    return true;
  }
}

const chatReadStore = new Store();
export default chatReadStore;